import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ComponentCanDeactivate} from './component-can-deactivate.guard';
import {AuthService} from '../../auth/auth.service';

@Injectable()
export class CanDeactivateGuard  {

  constructor(private authService: AuthService) {}

  canDeactivate(
    component: ComponentCanDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    if (this.authService.isLoggedOut()) {
      return true;
    }

    if (localStorage.getItem('delete')) {
      localStorage.removeItem('delete');
      return true;
    }

    // fixes not being able to navigate away if the component was destroyed
    if (component) {
      return component.canDeactivate ? component.canDeactivate() : true;
    }
    return true;
  }
}
